import { cn } from '@/lib/utils/cn'

/**
 * 2택 선택 — 주차 가능·샤워실·탈의실·스트링 작업 가능 여부 공용(`#867` 설계 §2).
 *
 * 🚨 `#865` 로 서버가 이 축을 3상태(`null`=미입력)에서 non-null `boolean` 으로 확정했다 — "미입력"
 * 옵션을 남겨 두면 실제로 저장되는 값(`false`)과 화면 표시가 어긋난다. 이름은 과거 3상태 시절 그대로
 * 유지한다(최소 diff — `VenueRegisterPage` 등 기존 소비처가 그대로 이 컴포넌트를 쓴다).
 */
const OPTIONS: { value: boolean; label: string }[] = [
  { value: false, label: '없음' },
  { value: true, label: '있음' },
]

export function VenueTriStateField({
  label,
  value,
  onChange,
}: {
  label: string
  value: boolean
  onChange: (value: boolean) => void
}) {
  return (
    <div>
      <span className="mb-1.5 block text-sm font-medium text-ink-700">{label}</span>
      <div role="radiogroup" aria-label={label} className="inline-flex rounded-lg border border-slateish-300 p-0.5">
        {OPTIONS.map((option) => (
          <button
            key={String(option.value)}
            type="button"
            role="radio"
            aria-checked={value === option.value}
            onClick={() => {
              onChange(option.value)
            }}
            className={cn(
              'rounded-md px-3 py-1.5 text-sm transition-colors',
              value === option.value ? 'bg-brand-500 text-white' : 'text-slateish-600 hover:bg-slateish-100'
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
